import { TableRow } from "@/components/Table";
import { BuilderBlockProps } from "@/types";
import { FC, PropsWithChildren } from "react";

export const TableRowBlock: FC<PropsWithChildren<BuilderBlockProps>> = ({
  children,
  ...props
}) => <TableRow {...props}>{children}</TableRow>;
